import { type LeadRiskLevel, type LeadStatus, type LeadVertical } from "./lead-submission";

export const ADMIN_TOKEN_HEADER = "x-admin-token";
export const LOCAL_ADMIN_TOKEN_FALLBACK = "llmad-local-admin-token";
export const ADMIN_TOKEN_STORAGE_KEY = "llmad-admin-token";

export interface AdminLeadRecord {
  id: string;
  name: string;
  vertical: LeadVertical;
  riskLevel: LeadRiskLevel;
  notes: string;
  contactName: string;
  contactHandle: string;
  source: string;
  status: LeadStatus;
  createdAt: string;
}

export function getAdminTokenFromHeaders(headers: Headers) {
  const headerToken = headers.get(ADMIN_TOKEN_HEADER)?.trim();

  if (headerToken) {
    return headerToken;
  }

  const authorization = headers.get("authorization")?.trim() ?? "";

  if (authorization.toLowerCase().startsWith("bearer ")) {
    return authorization.slice(7).trim();
  }

  return "";
}

export function isValidAdminToken(headers: Headers, expectedToken: string | null | undefined) {
  if (!expectedToken) {
    return false;
  }

  return getAdminTokenFromHeaders(headers) === expectedToken;
}

export function mapLeadRowToAdminRecord(row: Record<string, unknown>): AdminLeadRecord {
  return {
    id: String(row.id ?? ""),
    name: String(row.name ?? ""),
    vertical: String(row.vertical ?? "travel") as LeadVertical,
    riskLevel: String(row.risk_level ?? "query") as LeadRiskLevel,
    notes: String(row.notes ?? ""),
    contactName: String(row.contact_name ?? ""),
    contactHandle: String(row.contact_handle ?? ""),
    source: String(row.source ?? "landing-page"),
    status: String(row.status ?? "new") as LeadStatus,
    createdAt: String(row.created_at ?? ""),
  };
}
